import type { ReviewableOrder } from '@src/orders/domain/ReviewableOrder';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const GET_REVIEWABLE_ORDER_KEY = ['reviewableOrder.get'];

export const useReviewableOrder = ({ id }: { id: string }) => {
  const { data: order, isLoading } = useQuery({
    queryKey: [...GET_REVIEWABLE_ORDER_KEY, id],
    queryFn: () => {
      return OrdersClient.findReviewableOrder(id);
    },
  });

  return {
    isLoading,
    order,
  };
};

export const useUpdateReviewableOrder = () => {
  const queryClient = useQueryClient();

  const updateReviewableOrder = ({
    updatedOrder,
  }: {
    updatedOrder: ReviewableOrder;
  }) => {
    queryClient.setQueryData(
      [...GET_REVIEWABLE_ORDER_KEY, updatedOrder.id],
      updatedOrder,
    );
  };

  return { updateReviewableOrder };
};

export const useRefreshInvoice = ({ orderId }: { orderId: string }) => {
  const queryClient = useQueryClient();

  const refreshInvoice = useCallback(() => {
    void queryClient.resetQueries({
      queryKey: [...GET_REVIEWABLE_ORDER_KEY, orderId],
    });
  }, [orderId, queryClient]);

  return { refreshInvoice };
};
